var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 20V11.3462L12.5 5L20 11.3462V20H14.8077V15.3846H10.1923V20H5Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }